/**
 * Home page FAQ entries
 *
 * Drives:
 *   - <FaqSection /> visible accordion on the homepage
 *   - FAQPage JSON-LD schema injected via SEO on the homepage
 *
 * Answers must be plain text (no markup). JSON-LD strips HTML, and the visible
 * section renders the answer as a paragraph.
 */
export const HOME_FAQS = [
  {
    id: 'starting-age',
    question: 'What age can my child start training at Owaza?',
    answer:
      "Our Kids program begins at age 5, our Youth program covers ages 9–17, and Adults are 18+. For children under 5, reach out and we'll talk through readiness — every kid is different.",
  },
  {
    id: 'styles-taught',
    question: 'What styles do you teach in Spring Hill, FL?',
    answer:
      "We're a traditional dojo offering Jujitsu, Aikido, Judo, and Karate, plus Yoga, Tai Chi, Women's Self-Defense, and Cane Self-Defense. All taught by Hanshi Jim Rivera and our senior instructors.",
  },
  {
    id: 'styles-difference',
    question: "What's the difference between Jujitsu, Karate, Judo, and Aikido?",
    answer:
      "Karate emphasizes striking; Judo focuses on throws and grappling; Jujitsu blends both with joint locks and ground work; Aikido uses an opponent's energy against them. Many of our students train across multiple arts — they reinforce each other.",
  },
  {
    id: 'free-trial',
    question: 'Do you offer a free trial class?',
    answer:
      "Yes — your first visit is on us. Call (352) 428-0086 and ask for Hanshi Jim Rivera to set up a time to come watch a class or try one.",
  },
  {
    id: 'what-to-wear',
    question: 'What should my child wear to their first class?',
    answer:
      "Comfortable workout clothes — t-shirt and athletic pants or shorts. When they're ready to commit, we'll get them fitted for a gi (uniform).",
  },
  {
    id: 'kids-safety',
    question: 'Is martial arts safe for kids?',
    answer:
      'Yes. Our program emphasizes control, respect, and discipline before contact. Kids classes are taught at age-appropriate intensity, and our instructors are trained to keep every student safe.',
  },
  {
    id: 'training-frequency',
    question: 'How often should I (or my child) train per week?',
    answer:
      "Most students see steady progress training 2–3 times per week. We're open Monday–Thursday for regular classes; Friday, Saturday, and Sunday are by appointment, invitation, or private.",
  },
  {
    id: 'location',
    question: 'Where are you located?',
    answer:
      '14726 County Line Rd, Spring Hill, FL 34610 — serving the Spring Hill, Brooksville, and Hernando County area.',
  },
];

export default HOME_FAQS;
